var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Startsida","stroke":"none","strokeWidth":"1","fill":"currentColor","fillRule":"evenodd","transform":"translate(-1045 -117)"},React.createElement("g",{"id":"Group-22","transform":"translate(0 13)","fill":"currentColor"},React.createElement("g",{"id":"Group-3-Copy-3","transform":"translate(868 99)"},React.createElement("path",{"d":"M188.906 5.13a.396.396 0 00-.293-.13.396.396 0 00-.291.13l-4.989 5.133-4.988-5.132a.396.396 0 00-.292-.13.396.396 0 00-.292.13l-.634.653a.418.418 0 000 .6l5.914 6.086c.085.087.182.13.292.13.11 0 .208-.043.292-.13l5.915-6.086a.418.418 0 000-.6l-.634-.653z","id":"Shape"})))));
}

ArrowDown.defaultProps = {"width":"13","height":"8","viewBox":"0 0 13 8"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
